import { useState, useEffect } from 'react';

export type DockMode = 'docked' | 'undocked';

interface DockState {
  dockMode: DockMode;
  setDockMode: (mode: DockMode) => void;
  toggleDockMode: () => void;
}

export const useDockState = (): DockState => {
  const [dockMode, setDockModeState] = useState<DockMode>('docked');

  // Load dock preference from localStorage on mount
  useEffect(() => {
    const savedDockMode = localStorage.getItem('dock_mode') as DockMode;
    if (savedDockMode && (savedDockMode === 'docked' || savedDockMode === 'undocked')) {
      setDockModeState(savedDockMode);
    }
  }, []);

  // Save dock preference to localStorage
  const setDockMode = (mode: DockMode) => {
    setDockModeState(mode);
    localStorage.setItem('dock_mode', mode);
  };

  const toggleDockMode = () => {
    const newMode = dockMode === 'docked' ? 'undocked' : 'docked';
    setDockMode(newMode);
  };

  return {
    dockMode,
    setDockMode,
    toggleDockMode,
  };
};